import React from 'react';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";

import {createUserStatus} from "../../../../creators/user.status";

import InputPost from '../../InputPost';


class PublishStatus extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(content) {
        this.props.createUserStatus(this.props.userId, content);
    }

    render() {
        return (
            <div className="card publish-status">

                    <div className="text">
                        {this.props.isMe ? (
                            "Publier sur votre mur"
                        ) : (
                            `Publier sur le mur de ${this.props.user.username || ""}`
                        )}
                    </div>

                    <InputPost sendBtn={true}
                               btnContent={this.props.isMe ? 'Publier votre statut' : 'Publier le statut'}
                           emoji={true}
                           editorStyle={"add-status"}
                           placeholder={`${this.props.currentUser.username ? `${this.props.currentUser.username}, ` : ""}écrivez ce que vous avez en tête ...`}
                           handleSubmit={this.handleSubmit}
                           loading={this.props.userStatusSubmitting}
                           canOptions={{subject : "Status", action : "create", passThrough : true}}
                           {...this.props}
                />

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userStatus: state.userStatus,
        userStatusLoading: state.userStatus.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createUserStatus
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PublishStatus);